// types used by the notifications service
// https://cosgit1.ds.jdsu.net/projects/CS/repos/cs-ms-notifications/browse/spec/notifications-service.yaml

export enum IAlertType {
    APP = 'APP',
    SERVER = 'SERVER',
    SITE = 'SITE'
}

export enum ISeverityEnum {
    CRITICAL = 'critical',
    HIGH = 'high',
    MED = 'med',
    LOW = 'low',
    WARNING = 'warning'
}

export interface IApplicationAlertSeverity {
    alertType: IAlertType,
    minimumSeverity: ISeverityEnum,
    appId: number
}

export interface ISiteAlertSeverity {
    alertType: IAlertType,
    minimumSeverity: ISeverityEnum,
    siteId: number
}

export interface IAlertListRow {
    appId?: number,
    siteId?: number,
    name: string,
    minimumSeverity: ISeverityEnum
}
